import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AddDaysPipe } from "@shared/pipes/add-days.pipe";
import { BBCodeToHtmlPipe } from "@shared/pipes/bbcode-to-html.pipe";
import { CamelCaseToSentenceCasePipe } from "@shared/pipes/camel-case-to-sentence-case.pipe";
import { GroupBackgroundColorPipe } from "@shared/pipes/group-background-color.pipe";
import { GroupTextColorPipe } from "@shared/pipes/group-text-color.pipe";
import { HasValidUserSubscriptionPipe } from "@shared/pipes/has-valid-user-subscription.pipe";
import { HighlightPipe } from "@shared/pipes/highlight.pipe";
import { IsBetaTesterPipe } from "@shared/pipes/is-beta-tester.pipe";
import { IsEquipmentModeratorPipe } from "@shared/pipes/is-equipment-moderator.pipe";
import { IsInGroupPipe } from "@shared/pipes/is-in-group.pipe";
import { IsMarketplaceModeratorPipe } from "@shared/pipes/is-marketplace-moderator.pipe";
import { KeysPipe } from "@shared/pipes/keys.pipe";
import { LocalDatePipe } from "@shared/pipes/local-date.pipe";
import { Nl2BrPipe } from "@shared/pipes/nl2br.pipe";
import { NormalizeNotificationLinkPipe } from "@shared/pipes/normalize-notification-link.pipe";
import { NotificationContextIconPipe } from "@shared/pipes/notification-context-icon.pipe";
import { NullOrUndefinedPipe } from "@shared/pipes/null-or-undefined.pipe";
import { NumberSuffixPipe } from "@shared/pipes/number-suffix.pipe";
import { OrDefaultAvatarPipe } from "@shared/pipes/or-default-avatar/or-default-avatar.pipe";
import { RemoveBrPipe } from "@shared/pipes/remove-br.pipe";
import { SlugifyPipe } from "@shared/pipes/slugify.pipe";
import { TagBorderColorPipe } from "@shared/pipes/tag-border-color.pipe";
import { TagTextColorPipe } from "@shared/pipes/tag-text-color.pipe";
import { TimeagoWithFormatPipe } from "@shared/pipes/timeago-with-format.pipe";
import { TruncatePipe } from "@shared/pipes/truncate.pipe";
import { UtcToLocalPipe } from "@shared/pipes/utc-to-local.pipe";
import { YesNoIconPipe } from "@shared/pipes/yes-no-icon.pipe";
import { YesNoPipe } from "@shared/pipes/yes-no.pipe";

import { DomainFromUrlPipe } from "./domain-from-url.pipe";
import { EnsureUrlProtocolPipe } from "./ensure-url-protocol.pipe";
import { FixLegacyUserUrlsPipe } from "./fix-legacy-user-urls.pipe";
import { IsContentModeratorPipe } from "./is-content-moderator.pipe";
import { IsForumModeratorPipe } from "./is-forum-moderator.pipe";
import { IsImageModeratorPipe } from "./is-image-moderator.pipe";
import { IsIotdJudgePipe } from "./is-iotd-judge.pipe";
import { IsIotdReviewerPipe } from "./is-iotd-reviewer.pipe";
import { IsIotdStaffPipe } from "./is-iotd-staff.pipe";
import { IsIotdSubmitterPipe } from "./is-iotd-submitter.pipe";
import { IsProducerPipe } from "./is-producer.pipe";
import { IsRetailerPipe } from "./is-retailer.pipe";
import { IsSuperUserPipe } from "./is-superuser.pipe";
import { SafeNl2BrPipe } from "./safe-nl2br.pipe";
import { SanitizeHtmlPipe } from "./sanitize-html.pipe";
import { SmileyConverterPipe } from "./smiley-converter.pipe";

const pipes = [
  BBCodeToHtmlPipe,
  CamelCaseToSentenceCasePipe,
  DomainFromUrlPipe,
  EnsureUrlProtocolPipe,
  FixLegacyUserUrlsPipe,
  IsBetaTesterPipe,
  IsContentModeratorPipe,
  IsForumModeratorPipe,
  IsImageModeratorPipe,
  IsIotdJudgePipe,
  IsIotdReviewerPipe,
  IsIotdStaffPipe,
  IsIotdSubmitterPipe,
  IsEquipmentModeratorPipe,
  IsMarketplaceModeratorPipe,
  IsProducerPipe,
  IsRetailerPipe,
  IsSuperUserPipe,
  IsInGroupPipe,
  HasValidUserSubscriptionPipe,
  LocalDatePipe,
  NullOrUndefinedPipe,
  YesNoPipe,
  SlugifyPipe,
  Nl2BrPipe,
  YesNoIconPipe,
  KeysPipe,
  HighlightPipe,
  RemoveBrPipe,
  AddDaysPipe,
  UtcToLocalPipe,
  NumberSuffixPipe,
  OrDefaultAvatarPipe,
  GroupBackgroundColorPipe,
  GroupTextColorPipe,
  TagBorderColorPipe,
  TagTextColorPipe,
  TimeagoWithFormatPipe,
  TruncatePipe,
  NormalizeNotificationLinkPipe,
  NotificationContextIconPipe,
  SanitizeHtmlPipe,
  SafeNl2BrPipe,
  SmileyConverterPipe
];

@NgModule({
  declarations: pipes,
  imports: [CommonModule],
  exports: pipes,
  providers: pipes
})
export class PipesModule {}
